import { api } from '@@/services//api';

export const incidentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchIncidents: builder.query<
      { docs: Alacaza.Incident[] },
      { propertyId?: string; status?: string }
    >({
      query: ({ propertyId, status }) => ({
        url: `/partners/incidents`,
        params: { propertyId, status },
      }),
      providesTags: ['Incidents'],
    }),
    fetchIncident: builder.query<Alacaza.Incident, string>({
      query: (incidentId) => `partners/incidents/${incidentId}`,
      providesTags: ['Incidents'],
    }),
    createIncident: builder.mutation<
      Alacaza.Incident,
      Partial<Alacaza.Incident> & { userId: string }
    >({
      query: ({ userId, propertyId, ...body }) => ({
        url: `partners/incidents/${propertyId}/users/${userId}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Incidents'],
    }),
    patchIncident: builder.mutation<
      Alacaza.Incident,
      { incidentId: string; status?: string; type?: string }
    >({
      query: ({ incidentId, ...body }) => ({
        url: `partners/incidents/${incidentId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Incidents'],
    }),
    addIncidentComment: builder.mutation<
      Alacaza.Incident,
      { incidentId: string; body: string; isInternal?: boolean }
    >({
      query: ({ incidentId, body, isInternal }) => ({
        url: `partners/incidents/${incidentId}/comments`,
        method: 'POST',
        body: { body, isInternal: !!isInternal },
      }),
      invalidatesTags: ['Incidents'],
    }),
  }),
});

export const {
  useFetchIncidentsQuery,
  useFetchIncidentQuery,
  useAddIncidentCommentMutation,
  usePatchIncidentMutation,
  useCreateIncidentMutation,
} = incidentApi;
